import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { IAdminxStore } from '../../stores';

export function useJobGet(props: ICrudGetProps) {
	const { id, options } = props;
	const { jobStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			jobStore.getCrud().get(id, options);
		}
		// TODO - think maybe when unmount reset to crud model
	}, [location]);

	if (!id) {
		return null;
	}

	return { error: jobStore.getCrud().getHttpError(), isLoading: jobStore.getCrud().getIsLoading() };
}
